export default "__VITE_ASSET__3a53ce74__"